import {createAction, props} from '@ngrx/store';
import {ProtectedResourceAccess} from '../models/protected-resource-access.model';


export const saveResourceAccess = createAction(
  "[REST API] Save Resource Access",
  props<{ videoAccess: ProtectedResourceAccess }>()
);

export const courseReset = createAction(
  "[Resource Access Effect] Course Reset",
  props<{courseId:string}>()
);


